import {
  convertToLocalTime,
  numberOfTestsOnSample,
  formatMidasNumber,
  displayHFRValue,
  formatParentTestLabel,
  exportGroupedToExcel,
  convertMidasNumberToSearchValue,
} from "../../global";
//import MoreOptions from "@mui/icons-material/MoreVert";
import {useState, useEffect } from "react";
import { UXDataTableWithoutBody, StyledTableCell, UXDataTableNested, StyledTableBody, StyledTableRow, StyledTableCellLink } from "../../components/UXDataTable";
import {Checkbox, CircularProgress, IconButton,TableRow, Typography} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ResultDisplayBox from "../../components/ResultDisplay";
import ParentTests from "./ParentTests";
import ModalSimpleButton from "../../components/Modal/ModalSimpleButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Test from "../../api/LIMS/Test";

const myTestsCols = ['MIDAS Number', 'Tests', 'Sample Description', 'Additional Info','Chem ID', 'HFR', 'Data Owner', 'Access Group']
const myMethodCols = ['TSN', 'Container', 'Method', 'Method Description', 'Results','Facility','Parent Test','Status', 'Date Completed']
const externalLabCols = [
  'Lab Name', 
  'Shipping Address', 
  'Lab Contact', 
  'ExxonMobil Contact', 
  'Notes', 
  'Test Cost USD',
  'Required Size'    
]

const SearchTests = ({inputSearchCriteria, sampleSearchArray, dataIsLoading}) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const savedShowAll = localStorage.getItem("showAllTestsOnSearch");
  const initialShowAll = savedShowAll === null || savedShowAll === "true"
  const [showAll, setShowAll] = useState(initialShowAll);
  const [page, setPage] = useState(0);
  const determineStartArray = () => {
    return (sampleSearchArray ?? []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }
  const getArrayOfTests = (containers) => {
    let arrayTests = []

    containers.forEach(oContainer => {
      oContainer.tests.forEach(oTest => {
        arrayTests.push(oTest)        
      });
    });

    return (arrayTests.sort((a, b) => a.testSequenceNumber  - b.testSequenceNumber))
  }
  const [testRowOpen, setTestRowOpen] = useState([]);
  const [resultRowOpen, setResultRowOpen] = useState([]);
  const [parentTest, setParentTest] = useState(null);
  const [parentTestLabel, setParentTestLabel] = useState('');

  const [modalExternalLabsOpen, setModalExternalLabsOpen] = useState(false)
  const [modalExternalLabsButtonText, setModalExternalLabsButtonText] = useState('')
  const [modalExternalLabsTitle, setModalExternalLabsTitle] = useState('')
  const [modalExternalLabsText, setModalExternalLabsText] = useState('')
  const [selectedTest, setTestToExternalLabModal] = useState(null)
  const [isExporting, setIsExporting] = useState(false);

  const noDataMessage = `No tests found with midas number, chem id or sample owner = ${inputSearchCriteria}`

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleTestRowClick = (sampleName) => {
    const testRowOpenIndex = testRowOpen.indexOf(sampleName);
    let newTestRowOpen = [];

    if (testRowOpenIndex === -1) {
      newTestRowOpen = newTestRowOpen.concat(testRowOpen, sampleName);
    } else if (testRowOpenIndex === 0) {
      newTestRowOpen = newTestRowOpen.concat(testRowOpen.slice(1));
    } else if (testRowOpenIndex === testRowOpen.length - 1) {
      newTestRowOpen = newTestRowOpen.concat(testRowOpen.slice(0, -1));
    } else if (testRowOpenIndex > 0) {
      newTestRowOpen = newTestRowOpen.concat(
        testRowOpen.slice(0, testRowOpenIndex),
        testRowOpen.slice(testRowOpenIndex + 1)
      );
    }
    setTestRowOpen(newTestRowOpen);
  };

  const handleResultRowClick = (sampleName, sequenceNumber) => {
    const resultRowOpenIndex = resultRowOpen.indexOf(sampleName + "~" + sequenceNumber);
    let newResultRowOpen = [];

    if (resultRowOpenIndex === -1) {
      newResultRowOpen = newResultRowOpen.concat(resultRowOpen, sampleName + "~" + sequenceNumber);
    } else if (resultRowOpenIndex === 0) {
      newResultRowOpen = newResultRowOpen.concat(resultRowOpen.slice(1));
    } else if (resultRowOpenIndex === resultRowOpen.length - 1) {
      newResultRowOpen = newResultRowOpen.concat(resultRowOpen.slice(0, -1));
    } else if (resultRowOpenIndex > 0) {
      newResultRowOpen = newResultRowOpen.concat(
        resultRowOpen.slice(0, resultRowOpenIndex),
        resultRowOpen.slice(resultRowOpenIndex + 1)
      );
    }
    setResultRowOpen(newResultRowOpen);
  };

  const isTestRowOpen = (sampleName) => testRowOpen.indexOf(sampleName) !== -1;
  const isResultRowOpen = (sampleName, sequenceNumber) => resultRowOpen.indexOf(sampleName + "~" + sequenceNumber) !== -1;

  
  function openModalExternalLabs(title, text, buttonText) {
      setModalExternalLabsButtonText(buttonText)
      setModalExternalLabsOpen(true);
      setModalExternalLabsTitle(title);
      setModalExternalLabsText(text);
  }
  function closeModalExternalLabs() {
      setModalExternalLabsOpen(false);
      setTestToExternalLabModal(null);
  }

  function showAllTestsAndResults(_showAll) {
    const rows = [];
    const results = [];

    if(_showAll){
      determineStartArray().forEach((sampleRow) => {
        rows.push(sampleRow.sampleName);      
        
        getArrayOfTests(sampleRow.containers).forEach((testRow) => {
          results.push(`${sampleRow.sampleName}~${testRow.testSequenceNumber}`);
        })
      })
      
      setTestRowOpen(rows);
      setResultRowOpen(results);
    }
    else{
      setTestRowOpen([]);
      setResultRowOpen([]);
    }

    setShowAll(_showAll);
    localStorage.setItem("showAllTestsOnSearch", JSON.stringify(_showAll));
  }

  async function handleExportTestData() {
    try {
      setIsExporting(true);
      const sampleNames = [...new Set((sampleSearchArray ?? []).map((sample) => sample?.sampleName).filter(Boolean))];

      if (sampleNames.length === 0) {
        openModalExternalLabs("No data to export", "No test data found to export.", "OK");
        return;
      }

      const allRowsResponse = await Promise.all(sampleNames.map((sampleName) => Test.getExportBySample(sampleName)));
      const allRows = allRowsResponse
        .filter((response) => response?.message === "Success" && Array.isArray(response?.result))
        .flatMap((response) => response.result);

      if (allRows.length === 0) {
        openModalExternalLabs("No data to export", "No test data found to export.", "OK");
        return;
      }

      const exportRows = allRows.map((row) => ({
        TSN: row.tsn ?? row.Tsn ?? "",
        "Test Status": row.testStatus ?? row.TestStatus ?? "",
        Method: row.method ?? row.Method ?? "",
        "Method Description": row.methodDescription ?? row.MethodDescription ?? "",
        "Method Facility": row.methodFacility ?? row.MethodFacility ?? "",
        "External Laboratory": row.externalLaboratory ?? row.ExternalLaboratory ?? null,
        "Test Condition": row.testCondition ?? row.TestCondition ?? "",
        "PointTestResults.ResultComponentName":
          row.resultComponentName ?? row.ResultComponentName ?? "",
        "PointTestResults.UoMName": row.uoMName ?? row.UoMName ?? "",
        DisplayValue: row.displayValue ?? row.DisplayValue ?? "",
      }));

      const fileSuffix =
        sampleNames.length === 1
          ? convertMidasNumberToSearchValue(sampleNames[0])
          : `${sampleNames.length}_samples`;
      const sample = sampleSearchArray.find((item) => item.sampleName === sampleNames[0]);

      exportGroupedToExcel({
        objList: exportRows,
        excelName: `MIDAS_Test_Data_${fileSuffix}`,
        metadata:
          sampleNames.length === 1
            ? [
                {
                  label: "MIDAS Number",
                  value: sample?.sampleName ? formatMidasNumber(sample.sampleName) : "",
                  span: 2,
                },
                { label: "Sample Description", value: sample?.description, span: 3 },
                { label: "Additional Info", value: sample?.additionalSampleInformation, span: 3 },
                { label: "Chem ID", value: sample?.chemID, span: 2 },
              ]
            : [],
        columns: [
          { key: "TSN", label: "TSN", width: 8, align: "center" },
          { key: "Test Status", label: "Test Status", width: 16, align: "center" },
          { key: "Method", label: "Method", width: 18, align: "center" },
          { key: "Method Description", label: "Method Description", width: 38, align: "center" },
          { key: "Method Facility", label: "Method Facility", width: 16, align: "center" },
          { key: "External Laboratory", label: "External Laboratory", width: 40, align: "center" },
          { key: "Test Condition", label: "Test Condition", width: 38, align: "center" },
          {
            key: "PointTestResults.ResultComponentName",
            label: "Result Component Name",
            width: 32,
          },
          { key: "PointTestResults.UoMName", label: "UoM Name", width: 18, align: "center" },
          { key: "DisplayValue", label: "Display Value", width: 18, align: "center" },
        ],
        groups: [
          { label: "Test Information", startKey: "TSN", endKey: "Test Condition" },
          {
            label: "Result Information",
            startKey: "PointTestResults.ResultComponentName",
            endKey: "DisplayValue",
          },
        ],
        mergeRowsBy: [
          "TSN",
          "Test Status",
          "Method",
          "Method Description",
          "Method Facility",
          "External Laboratory",
          "Test Condition",
        ],
        groupBy: (row) =>
          [
            row.TSN,
            row["Test Status"],
            row.Method,
            row["Method Description"],
            row["Method Facility"],
            row["External Laboratory"],
            row["Test Condition"],
          ].join("|"),
      });
    } catch (error) {
      openModalExternalLabs("Export Failed", error?.message ?? "Failed to export test data.", "OK");
    } finally {
      setIsExporting(false);
    }
  }

  useEffect(() => {
    if (!showAll) {
      setTestRowOpen([]);
      setResultRowOpen([]);
      return;
    }

    const rows = [];
    const results = [];

    (sampleSearchArray ?? []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).forEach((sampleRow) => {
      rows.push(sampleRow.sampleName);
      getArrayOfTests(sampleRow.containers).forEach((testRow) => {
        results.push(
          `${sampleRow.sampleName}~${testRow.testSequenceNumber}`
        )
      })
    });

    setTestRowOpen(rows);
    setResultRowOpen(results);
  }, [showAll, sampleSearchArray, page, rowsPerPage])

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{fontWeight:"600",}}>Show all
          <Checkbox checked={showAll} color='primary' onClick={() => {showAllTestsAndResults(!showAll)}}/>
        </Typography>
        {!dataIsLoading && sampleSearchArray && sampleSearchArray.length > 0 && (
          isExporting ? (
            <CircularProgress
              aria-label="Downloading test data"
              size={24}
              sx={{ m: 1 }}
            />
          ) : (
            <FileDownloadIcon
              sx={{ m: 1 }}
              style={{ cursor: "pointer" }}
              titleAccess="Download test data"
              onClick={handleExportTestData}
            />
          )
        )}
      </div>
      <UXDataTableWithoutBody 
        tableWidth='100%' 
        cols={myTestsCols} 
        blankFirstHeader={false}
        tableId="myTestsTable"
        rowLength={sampleSearchArray ? sampleSearchArray.length : 0}
        enablePaging={true}
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        noDataFoundMessage={noDataMessage}
        enableAddIcon={false}
        addFunction={null}
        addToolTipText={null}  
        isDataLoading={dataIsLoading}
        >
  
          {sampleSearchArray && sampleSearchArray.length > 0 ? (
            determineStartArray().map((sampleRow, index) => {
              return (
                <StyledTableBody key={`myTestsTablebody${index}`}> 
                  <StyledTableRow>
                    <StyledTableCell component='th' scope='row' sx={{minWidth:"8rem"}}>
                      <b>
                        {formatMidasNumber(sampleRow.sampleName)}
                      </b>
                    </StyledTableCell>

                      <StyledTableCell align='right' style={{width:'5rem'}}>

                      {numberOfTestsOnSample(sampleRow.containers)}

                        <IconButton
                          aria-label='expand row'
                          size='small'
                          onClick={() => handleTestRowClick(sampleRow.sampleName)}>
                          {isTestRowOpen(sampleRow.sampleName) ? (
                            <KeyboardArrowUpIcon/>
                          ) : (
                            <KeyboardArrowDownIcon/>
                          )}
                        </IconButton>
                      </StyledTableCell>
                            
                      <StyledTableCell align='right'>{sampleRow.description}</StyledTableCell>
                      <StyledTableCell align='right'>{sampleRow.additionalSampleInformation}</StyledTableCell>
                      <StyledTableCell align='right'>{sampleRow.chemID}</StyledTableCell>
                      {/* <StyledTableCell align='right'>{sampleRow.parentSampleContainer ? formatMidasNumber(sampleRow.parentSampleContainer.sampleName) : ''}</StyledTableCell> */}

                      {sampleRow.substance ? (
                        <StyledTableCell align='right'>
                          {displayHFRValue(sampleRow.substance)}
                        </StyledTableCell>
                      ) : (<StyledTableCell align='right'>- -</StyledTableCell>)
                      }
                
                        <StyledTableCell align='right'>{sampleRow.sampleOwnerEmail}</StyledTableCell>
                        <StyledTableCell align='right'>{sampleRow.project?.name}</StyledTableCell>
                    </StyledTableRow>

                  {isTestRowOpen(sampleRow.sampleName) && (
                    <UXDataTableNested 
                    tableWidth={'100%'} 
                    cols={myMethodCols} 
                    blankFirstHeader={false} 
                    colSpan={myTestsCols.length + 1} 
                    isOpenComparator={sampleRow.sampleName} 
                    isOpenArray={testRowOpen}>

                    {/* {sampleRow.containers.map((containerRow) => (
                        containerRow.tests.map((testRow) => (   */}
                    {getArrayOfTests(sampleRow.containers).map((testRow) => (
                    <StyledTableBody key={`${sampleRow.sampleName}${testRow.testSequenceNumber}_"testtablebody"`}>
                      <StyledTableRow>
                        <StyledTableCell style={{width:'2rem'}}>{testRow.testSequenceNumber}</StyledTableCell>
                        <StyledTableCell style={{width:'2rem'}}>{sampleRow.containers.find(c => c.id === testRow.containerID).containerNumber}</StyledTableCell>
                        <StyledTableCell>{testRow.methodFacility?.methodName}</StyledTableCell>
                        <StyledTableCell>{testRow.methodFacility?.method?.description}</StyledTableCell>
                        <StyledTableCell style={{width:'4rem'}}>
                          <IconButton
                            aria-label='expand row'
                            size='small'
                            onClick={() => handleResultRowClick(sampleRow.sampleName, testRow.testSequenceNumber)}>
                            {isResultRowOpen(sampleRow.sampleName, testRow.testSequenceNumber) ? (
                              <KeyboardArrowUpIcon/>
                            ) : (
                              <KeyboardArrowDownIcon/>
                            )}
                          </IconButton>
                        </StyledTableCell>
                        <StyledTableCell>
                        <div style={{display:'flex', alignItems:'center'}}>
                        <span>   {testRow.methodFacility.testFacilityAbv}   </span> 

                               
                            <IconButton style={{ marginRight:"-2rem"}} sx={{ color: "black" }}
                                disabled={testRow.methodFacility?.testFacilityAbv !== "EXT" || testRow.methodFacility === null}
                                onClick ={() => {openModalExternalLabs("Selected External Laboratory", null, "OK");
                                  setTestToExternalLabModal(testRow)}} 
                            >
                                <VisibilityIcon>
                                </VisibilityIcon>
                            </IconButton>
                        </div>
                        </StyledTableCell>
                        <StyledTableCellLink onClick={() => {
                          setParentTest(testRow.parentTestID);
                          setParentTestLabel(formatParentTestLabel(testRow.parentTest));
                        }}>{formatParentTestLabel(testRow.parentTest)}</StyledTableCellLink>
                        <StyledTableCell>{testRow.testStatusName}</StyledTableCell>
                        <StyledTableCell>{convertToLocalTime(testRow.reportedDate)}</StyledTableCell>
                      </StyledTableRow>
                      <TableRow style={{paddingBottom:"0px",paddingTop:"0px", marginTop:"0px", marginBottom:"0px"}}>
                        <StyledTableCell colSpan={9} style={{paddingBottom:"0px",paddingTop:"0px", marginTop:"0px", marginBottom:"0px"}}>{isResultRowOpen(sampleRow.sampleName, testRow.testSequenceNumber) ? <ResultDisplayBox testID={testRow.id}></ResultDisplayBox> : null}</StyledTableCell>
                      </TableRow>
                      
                      </StyledTableBody>
                          ))
                      // ))
                    }
                    </UXDataTableNested>
                  )}
                  
                  </StyledTableBody>
              );
            })
          ) : (
            <StyledTableBody key={"no tests found"}>
              <TableRow key={"nothing found"}>
              <StyledTableCell colSpan='14' key={"nothing found cells"}>
                <p>{noDataMessage}</p>
              </StyledTableCell>
            </TableRow>
            </StyledTableBody>
          )}
    </UXDataTableWithoutBody>
    {parentTest && parentTest !== '' && <ParentTests open={parentTest && parentTest !== ''} setClose={() => setParentTest(null)} setParentTest={setParentTest} parentTest={parentTest} parentTestLabel={parentTestLabel}/>}
    <ModalSimpleButton title={modalExternalLabsTitle} buttonText={modalExternalLabsButtonText} buttonAction={closeModalExternalLabs}  open={modalExternalLabsOpen} setOpen={setModalExternalLabsOpen}>
            <label>
                {modalExternalLabsText}
            </label>

            <div style={{marginTop:"1rem"}}>

            <UXDataTableWithoutBody
                tableWidth='1250px' 
                cols={externalLabCols} 
                blankFirstHeader = {false}
                tableId= {`externalLabs`}
                rowLength={selectedTest ? selectedTest?.methodFacility?.methodExternalLabs?.length > 0 ? selectedTest?.methodFacility?.methodExternalLabs?.length : 0 : 0}
                enablePaging={false}
                rowsPerPage={0}
                page={0}
                handleChangePage={null}
                handleChangeRowsPerPage={null}
                noDataFoundMessage={'No labs found'}
                enableAddIcon={false}
                addFunction={null}
                addToolTipText={''}  
                isDataLoading={false}
            >
                {selectedTest && selectedTest?.methodFacility && selectedTest.methodFacility.methodExternalLabs.filter((x => x.externalLaboratory.laboratoryName === selectedTest.externalLaboratoryName)).map((oExternalLab, index) => {
                    return(
                        <StyledTableBody key={`SearchedSamples~${index}`}>
                            <TableRow> 
                                <StyledTableCell>
                                    {oExternalLab.externalLaboratory.laboratoryName}
                                </StyledTableCell>

                                <StyledTableCell>
                                    {oExternalLab.externalLaboratory.shippingAddress ? 
                                    `${oExternalLab.externalLaboratory.shippingAddress?.address1} ${oExternalLab.externalLaboratory.shippingAddress?.city}, ${oExternalLab.externalLaboratory.shippingAddress?.state}`
                                    : 'N/A'}
                                </StyledTableCell>

                                <StyledTableCell>
                                    {oExternalLab.externalLaboratory.labContactEmailAddress}
                                </StyledTableCell>

                                <StyledTableCell>
                                    {oExternalLab.externalLaboratory.onSiteContactEmailAddress}
                                </StyledTableCell>

                                <StyledTableCell>
                                    {oExternalLab.externalLaboratory.notes}
                                </StyledTableCell>

                                <StyledTableCell>
                                    {oExternalLab.testCostUSD != null ? `$${oExternalLab.testCostUSD.toLocaleString()}` : 'N/A'}
                                </StyledTableCell>

                                <StyledTableCell>
                                    {oExternalLab.minimumSampleAmount ? `${oExternalLab.minimumSampleAmount} ${oExternalLab.minimumSampleAmountUoM}` : 'N/A'}
                                </StyledTableCell>
                                  
                            </TableRow>
                        </StyledTableBody>
                    )
                })}
            </UXDataTableWithoutBody>
            </div>
        </ModalSimpleButton>
    </>
    );
};

export default SearchTests;
